const MONTH_LONG_TO_SHORT = {
  january: 'Jan',
  february: 'Feb',
  march: 'Mar',
  april: 'Apr',
  may: 'May',
  june: 'Jun',
  july: 'Jul',
  august: 'Aug',
  september: 'Sep',
  october: 'Oct',
  november: 'Nov',
  december: 'Dec',
};

export const abbreviateLongMonthNamesInString = (s) => {
  if (!s) return '';
  let out = String(s);
  Object.entries(MONTH_LONG_TO_SHORT).forEach(([longForm, shortForm]) => {
    out = out.replace(new RegExp(`\\b${longForm}\\b`, 'gi'), shortForm);
  });
  return out;
};

export const stripClockHourLeadingZero = (str) =>
  String(str || '').replace(/\b0(\d{1,2}:\d{2}\s*(?:AM|PM)?)\b/gi, '$1');

/** Plain text for note preview + tooltips (API may return HTML). */
export const stripHtmlToPlain = (html) => {
  if (html == null || html === '') return '';
  const s = String(html).replace(/<br\s*\/?>/gi, ' ').replace(/<\/p>/gi, ' ');
  return s.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
};
